function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.25 -10.125)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.694,10.125,28.046,20.838,26.4,10.125H24.75l2.073,11.537h2.446l2.074-11.537Z",
  transform: "translate(-6.018)",
  fill: "#d6d6d6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.444,21.662H13.5V20.014h4.944v-3.3h-3.3A1.65,1.65,0,0,1,13.5,15.069v-3.3a1.65,1.65,0,0,1,1.648-1.648h4.944v1.648H15.148v3.3h3.3a1.65,1.65,0,0,1,1.648,1.648v3.3a1.65,1.65,0,0,1-1.648,1.648Z",
  transform: "translate(-3.009)",
  fill: "#d6d6d6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.843,21.662H3.9A1.65,1.65,0,0,1,2.25,20.014V11.773A1.65,1.65,0,0,1,3.9,10.125H8.843v1.648H3.9v8.241H8.843Z",
  fill: "#d6d6d6"
}));

var SvgCsv = function SvgCsv(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.074,
    height: 11.537,
    viewBox: "0 0 23.074 11.537",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCsv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/csv.136bdc07.svg";
export { ForwardRef as ReactComponent };